import React from 'react';
import { PRODUCT_IMAGES } from '../../data/products';
const labels = ['High-positive rake', 'Polished APGX insert', 'Replaceable insert screw', 'Directed chip path'];
function ChipFlowLines() {
  return <svg aria-hidden="true" focusable="false" viewBox="0 0 400 260" preserveAspectRatio="none" className="pointer-events-none absolute inset-0 h-full w-full" data-id="element-123" data-mp="3ucf4oq4i93sr">
      <g stroke="#C7CDD3" strokeOpacity="0.28" strokeWidth="1" fill="none" data-id="element-124" data-mp="8347cy8vgtpd">
        <path d="M40 200 C 120 200, 150 150, 190 120" data-id="element-125" data-mp="35luwxvnbwcm" />
        <path d="M40 214 C 130 214, 168 160, 214 126" data-id="element-126" data-mp="34syoqubcp8q" />
        <path d="M40 228 C 140 228, 186 172, 238 132" data-id="element-127" data-mp="h53qbw3g67uy" />
      </g>
      <g stroke="#B66A33" strokeOpacity="0.5" strokeWidth="1" fill="none" data-id="element-128" data-mp="c5r33a8nyyru">
        <path d="M232 120 C 268 96, 300 92, 344 100" data-id="element-129" data-mp="c6jyjf26a1uo" />
        <path d="M236 132 C 276 112, 308 110, 352 120" data-id="element-130" data-mp="2ivf4z9ftvmop" />
      </g>
      <g stroke="#C7CDD3" strokeOpacity="0.16" strokeWidth="1" data-id="element-131" data-mp="2dx57utajmc0g">
        <line x1="0" y1="60" x2="400" y2="60" data-id="element-132" data-mp="2dyopoobukv4c" />
        <line x1="0" y1="196" x2="400" y2="196" data-id="element-133" data-mp="1lyuwjsok7y16" />
        <line x1="72" y1="0" x2="72" y2="260" data-id="element-134" data-mp="1m05zjqa6l1r8" />
        <line x1="328" y1="0" x2="328" y2="260" data-id="element-135" data-mp="1qxfvlos2sbo1" />
      </g>
    </svg>;
}
function Specimen() {
  return <div className="relative" data-id="element-136" data-mp="1vw8xsl1wwg8w">
      <ChipFlowLines data-id="element-137" data-mp="1vw0nn0x6bp1e" />
      <div className="relative flex flex-col items-center gap-8 px-2 py-8 sm:py-12" data-id="element-138" data-mp="1vupioxrzsb8p">
        <figure className="w-full max-w-[320px]" data-id="element-139" data-mp="20p277m8bscrb">
          <img src={PRODUCT_IMAGES.holder} alt="Shear Geometry external CNC lathe tool holder, legacy product photograph" width={250} height={68} className="h-auto w-full border border-white/10" data-id="element-140" data-mp="24pm0geps2w86" />
          <figcaption className="mt-2.5 font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-141" data-mp="2el7bf2ctr6u2">
            LEGACY PHOTOGRAPH — HOLDER
          </figcaption>
        </figure>

        <div aria-hidden="true" className="h-px w-24 bg-gradient-to-r from-transparent via-copper to-transparent opacity-60" data-id="element-142" data-mp="katv6ll6lltx" />

        <figure className="w-full max-w-[176px]" data-id="element-143" data-mp="h74gakpw1so3">
          <div className="aspect-square w-full border border-white/10 bg-black/20" data-id="element-144" data-mp="h7wc9wnedsew">
            <img src={PRODUCT_IMAGES.insert} alt="Polished APGX insert used with the Shear Geometry holder, legacy product photograph" loading="lazy" className="h-full w-full object-contain" data-id="element-145" data-mp="ca4amawyarxi" />
          </div>
          <figcaption className="mt-2.5 font-mono text-[9.5px] tracking-label text-aluminum/70" data-id="element-146" data-mp="105qik2x55ptl">
            LEGACY PHOTOGRAPH — INSERT
          </figcaption>
        </figure>
      </div>
    </div>;
}
function LabelLine({
  text,
  side
}: {
  text: string;
  side: 'left' | 'right';
}) {
  return <div className={`flex items-center gap-3 ${side === 'left' ? 'justify-end text-right' : 'justify-start text-left'}`} data-id="element-147" data-mp="14wysr16apf7t">
      {side === 'right' ? <span aria-hidden="true" className="h-px w-6 shrink-0 bg-copper/70" data-id="element-148" data-mp="1evoc6ydub7q6" /> : null}
      <span className="font-mono text-[10px] leading-tight tracking-[0.08em] text-aluminum" data-id="element-149" data-mp="1xjp1p6uvo85a">
        {text}
      </span>
      {side === 'left' ? <span aria-hidden="true" className="h-px w-6 shrink-0 bg-copper/70" data-id="element-150" data-mp="22hi9u5fqrc87" /> : null}
    </div>;
}
export function HeroSpecimen() {
  return <div className="rp-grid-lines-dark relative overflow-hidden border border-white/10 bg-graphite p-5 sm:p-8" data-id="element-151" data-mp="1ti3lpcn1rdqv">
      <p className="font-mono text-[9.5px] tracking-label text-copper" data-id="element-152" data-mp="1esp8tuk9ie6q">
        SHEAR GEOMETRY / HOLDER + INSERT
      </p>

      {/* Wide: labels flank the specimen */}
      <div className="mt-6 hidden grid-cols-[minmax(0,140px)_minmax(0,1fr)_minmax(0,140px)] items-center gap-x-5 gap-y-10 lg:grid" data-id="element-153" data-mp="1jls5ibkc63r5">
        <div className="space-y-10" data-id="element-154" data-mp="19tmeb41wrqd0">
          <LabelLine text={labels[0]} side="left" data-id="element-155" data-mp="19unnf2zd62s3" />
          <LabelLine text={labels[2]} side="left" data-id="element-156" data-mp="vumlrlb9yrbk" />
        </div>
        <Specimen data-id="element-157" data-mp="vwfwpcsx7xpd" />
        <div className="space-y-10" data-id="element-158" data-mp="10tg1zlhy4wff">
          <LabelLine text={labels[1]} side="right" data-id="element-159" data-mp="10seh6pb4ovki" />
          <LabelLine text={labels[3]} side="right" data-id="element-160" data-mp="10vahuled1ycn" />
        </div>
      </div>

      {/* Narrow: specimen then a two-up label key */}
      <div className="lg:hidden" data-id="element-161" data-mp="1z50hgaewugwg">
        <div className="mt-4" data-id="element-162" data-mp="1z5scnk4licm7">
          <Specimen data-id="element-163" data-mp="1uek6cwykb7d9" />
        </div>
        <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-3 border-t border-white/10 pt-5" data-id="element-164" data-mp="1udqy1rjyg9t0">
          {labels.map(label => <li key={label} className="flex items-start gap-2" data-id="element-165" data-mp="1pf77fduf29ub">
              <span aria-hidden="true" className="mt-1.5 h-px w-3 shrink-0 bg-copper" data-id="element-166" data-mp="1kgmg63x570i0" />
              <span className="font-mono text-[10px] leading-tight tracking-[0.06em] text-aluminum" data-id="element-167" data-mp="1ffygktuulbc6">
                {label}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}